




/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const CONNECTIONREQUESTPOST= createAsyncThunk(
  "ConnectionRequestPost/ConnectionRequestPost",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const ConnectionRequestPostSlice = createSlice({
  name: "ConnectionRequestPostSlice",
  initialState: {
    ConnectionRequestPost: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfConnectionRequestPost: (state) => {
        state.ConnectionRequestPost.loading = false
        state.ConnectionRequestPost.error = false
        state.ConnectionRequestPost.data = []
        state.ConnectionRequestPost.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(CONNECTIONREQUESTPOST.fulfilled, (state, action) => {
      state.ConnectionRequestPost = {
        ...state.ConnectionRequestPost,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CONNECTIONREQUESTPOST.pending, (state, action) => {
      state.ConnectionRequestPost = {
        ...state.ConnectionRequestPost,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CONNECTIONREQUESTPOST.rejected, (state, action) => {
      state.ConnectionRequestPost = {
        ...state.ConnectionRequestPost,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const ConnectionRequestPostAction = {
    CONNECTIONREQUESTPOST,
};

export { ConnectionRequestPostAction };
export default ConnectionRequestPostSlice.reducer;
export const {setInitialStateOfConnectionRequestPost} = ConnectionRequestPostSlice.actions
